
import { IconProps } from './types';

const ArrowDownIcon = ({ size = 24, ...rest }: IconProps) => {
  return (
    <svg width={size} height={size} viewBox='0 0 17 14' fill='none' {...rest}>
      <path
        d='M.792 2.696a.565.565 0 01-.112-.364c0-.15.093-.308.28-.476.187-.168.504-.383.952-.644l.196-.112C2.78.727 3.228.54 3.452.54c.168 0 .299.075.392.224l4.928 8.4L13.784.596c.093-.13.196-.196.308-.196.224 0 .681.205 1.372.616l.196.112c.485.28.821.495 1.008.644.187.15.28.29.28.42 0 .075-.037.187-.112.336l-6.44 10.92c-.112.224-.27.364-.476.42-.205.056-.55.084-1.036.084h-.252c-.504 0-.85-.028-1.036-.084-.187-.056-.345-.196-.476-.42L.792 2.696z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ArrowDownIcon;
